// extracted by mini-css-extract-plugin
export var container = "HomeProjectsSection-module--container--2xXFR";
export var title = "HomeProjectsSection-module--title--2NX9D";
export var projectsContainer = "HomeProjectsSection-module--projectsContainer--2pvX_";
export var arrowContainer = "HomeProjectsSection-module--arrowContainer--3S55f";
export var arrowLabel = "HomeProjectsSection-module--arrowLabel--2ehUI";
export var arrow = "HomeProjectsSection-module--arrow--2m0xu";
export var arrowBounce = "HomeProjectsSection-module--arrowBounce--16FdJ";